import React from 'react';

/**
 * SaveStatusIndicator - Small inline auto-save status display
 * Brutalist style: monospace uppercase tracking-wider
 */
export default function SaveStatusIndicator({ status, errorMessage }) {
  if (status === 'idle') return null;

  const config = {
    saving: { text: 'SAVING...', color: 'text-gray-500' },
    saved: { text: 'SAVED', color: 'text-green-600' },
    error: { text: errorMessage || 'SAVE FAILED', color: 'text-red-600' },
  };

  const { text, color } = config[status] || {};
  if (!text) return null;

  return (
    <span className={`font-mono text-xs uppercase tracking-wider ${color}`}>
      {text}
    </span>
  );
}
